import { config } from "../config";
export const getNumberFormatter = (options) => {
    return new Intl.NumberFormat(config.get.locale, options);
};
export const getDateTimeFormatter = (options) => {
    return new Intl.DateTimeFormat(config.get.locale, options);
};
//# sourceMappingURL=localizationApi.js.map